var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[(_vm.url)?_c('a-avatar',{attrs:{"size":_vm.size,"src":_vm.filePreview(_vm.url)}}):(_vm.name)?_c('a-avatar',{staticClass:"avatar-name",attrs:{"size":_vm.size}},[_vm._v(_vm._s(_vm.name.charAt(0)))]):_c('a-avatar',{attrs:{"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }